class LoadMorePLP extends HTMLElement {
  constructor() {
    super();
    this.ELM_loadMoreBtn = this.querySelector(".js-load-more");
    this.ELM_productGrid = this.querySelector(".product-grid");
    this.ELM_productCount = this.querySelector("[data-products-current-count]");
    this.totalProducts = this.getAttribute("data-total-products");
    this.ELM_loadMoreBtn?.addEventListener("click", () =>
      this.handleLoadMore(),
    );
  }

  handleLoadMore() {
    fetch(this.ELM_productGrid.getAttribute("data-next-url"))
      .then((res) => res.text())
      .then((res) => {
        const html = new DOMParser().parseFromString(res, "text/html");
        const newProductGrid = html.querySelector(".product-grid");
        const totalPages = newProductGrid.getAttribute("data-total-page");
        const currentPage = newProductGrid.getAttribute("data-current-page");
        const numberTotalPage = parseInt(totalPages);
        const numberCurrentPage = parseInt(currentPage);
        const newProductCount = html.querySelector(
          "[data-products-current-count]",
        );

        this.ELM_productGrid.innerHTML += newProductGrid.innerHTML;
        this.ELM_productGrid.setAttribute(
          "data-next-url",
          newProductGrid.getAttribute("data-next-url"),
        );
        this.ELM_productGrid.setAttribute("data-current-page", currentPage);

        if (numberCurrentPage >= numberTotalPage) {
          this.ELM_loadMoreBtn.classList.add("d-none");
        }

        this.ELM_productCount.innerHTML = newProductCount.innerHTML;

        document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
      });
  }
}

customElements.define("load-more-plp", LoadMorePLP);
